document.addEventListener("DOMContentLoaded", () => {
    const popupOpenLinks = document.querySelectorAll(".expertness__popup--open");
    const popupCloseLinks = document.querySelectorAll(".expertness__popup--close");

    const openPopup = (element) => {
        const expertnessCol = element.closest(".expertness__col");
        if (expertnessCol) {
            expertnessCol.classList.add("popup-opened");
            document.body.classList.add("popup-opened");
        }
    };

    const closePopup = () => {
        const openedCol = document.querySelector(".expertness__col.popup-opened");
        if (openedCol) {
            openedCol.classList.remove("popup-opened");
        }
        document.body.classList.remove("popup-opened");
    };

    popupOpenLinks.forEach((link) => {
        link.addEventListener("click", (event) => {
            event.preventDefault();
            openPopup(link);
        });
    });

    popupCloseLinks.forEach((closeLink) => {
        closeLink.addEventListener("click", (event) => {
            event.preventDefault();
            closePopup();
        });
    });

    document.addEventListener("click", (event) => {
        const expertnessCol = event.target.closest(".expertness__col");
        if (!expertnessCol || !event.target.closest(".expertness__popup-hold") && !event.target.closest(".expertness__popup--open")) {
            closePopup();
        }
    });

    document.addEventListener("keydown", (event) => {
        if (event.key === "Escape") {
            closePopup();
        }
    });
});
